<template>
    <header
        class="site-search__header"
        :class="{
            'site-search__header--loading': loading,
            'site-search__header--no-results': !loading && results?.length === 0,
        }"
    >
        <div class="site-search__header-inner">
            <h1 class="site-search__title visually-hidden">
                {{ props.title }}
            </h1>

            <h2 class="site-search__default" v-if="results?.length == 0 && !loading" v-cloak>
                No Results Found
            </h2>

            <div class="search-form__wrapper">
                <form class="search-form" method="get">
                    <button class="search-form__remove">
                        <span class="visually-hidden">Remove</span>
                        <svg class="o-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M10 10.9315L13.4 14.3315C13.4599 14.393 13.5314 14.442 13.6105 14.4755C13.6896 14.509 13.7746 14.5263 13.8605 14.5265C13.9482 14.5286 14.0353 14.5124 14.1164 14.4788C14.1974 14.4452 14.2705 14.395 14.331 14.3315C14.3942 14.2715 14.4445 14.1993 14.479 14.1192C14.5134 14.0391 14.5311 13.9529 14.5311 13.8657C14.5311 13.7786 14.5134 13.6923 14.479 13.6123C14.4445 13.5322 14.3942 13.46 14.331 13.4L10.931 10L14.331 6.60009C14.3925 6.54021 14.4415 6.46863 14.475 6.38954C14.5085 6.31046 14.5258 6.22548 14.526 6.1396C14.5285 6.05186 14.5124 5.96458 14.4788 5.8835C14.4452 5.80241 14.3948 5.72935 14.331 5.66911C14.2711 5.6057 14.199 5.55519 14.119 5.52066C14.0389 5.48613 13.9527 5.46832 13.8655 5.46832C13.7783 5.46832 13.692 5.48613 13.612 5.52066C13.532 5.55519 13.4598 5.6057 13.4 5.66911L10 9.06905L6.6001 5.66911C6.5401 5.60763 6.46851 5.55865 6.38947 5.52501C6.31043 5.49137 6.2255 5.47373 6.1396 5.47311C6.05182 5.47095 5.96457 5.48729 5.88351 5.52105C5.80245 5.55482 5.7294 5.60526 5.66911 5.66911C5.60584 5.72901 5.55544 5.80118 5.52099 5.88121C5.48655 5.96125 5.46879 6.04747 5.46879 6.1346C5.46879 6.22173 5.48655 6.30795 5.52099 6.38798C5.55544 6.46802 5.60584 6.54019 5.66911 6.60009L9.06906 10L5.66911 13.4C5.60751 13.4599 5.55852 13.5316 5.52503 13.6108C5.49154 13.6899 5.47423 13.775 5.47412 13.861C5.4717 13.9487 5.48783 14.0359 5.52143 14.117C5.55503 14.1981 5.60535 14.2712 5.66911 14.3315C5.72901 14.3947 5.80119 14.4451 5.88122 14.4796C5.96126 14.514 6.04747 14.5318 6.1346 14.5318C6.22174 14.5318 6.30795 14.514 6.38799 14.4796C6.46802 14.4451 6.5402 14.3947 6.6001 14.3315L10 10.9315ZM10 19.9999C8.6643 20.008 7.3413 19.7399 6.1141 19.2124C3.71628 18.1938 1.80694 16.285 0.787693 13.8875C0.259611 12.6599 -0.00851538 11.3363 0.000206131 10C-0.00848137 8.65976 0.259432 7.33211 0.787193 6.1001C1.29175 4.91396 2.02039 3.83629 2.93316 2.92615C3.84856 2.019 4.92758 1.29355 6.1131 0.788186C7.34043 0.259931 8.66388 -0.00836758 10 0.000199289C11.3403 -0.00837334 12.668 0.259712 13.9 0.787686C16.2949 1.79926 18.2008 3.70515 19.2124 6.1001C19.7408 7.33193 20.0089 8.65968 19.9999 10C20.008 11.3357 19.7401 12.6587 19.2129 13.886C18.7074 15.0717 17.9822 16.1512 17.0754 17.0674C16.1646 17.9799 15.0864 18.7083 13.9 19.2129C12.668 19.7408 11.3403 20.0088 10 19.9999ZM10 18.6774C11.1437 18.6985 12.2796 18.4848 13.3374 18.0495C14.3952 17.6141 15.3524 16.9664 16.1499 16.1464C16.9682 15.3485 17.6145 14.3916 18.0492 13.3346C18.4838 12.2775 18.6976 11.1428 18.6774 10C18.6984 8.85668 18.485 7.72113 18.0503 6.66343C17.6156 5.60572 16.9689 4.64827 16.1499 3.85014C15.3519 3.03112 14.3944 2.38431 13.3367 1.94961C12.279 1.51491 11.1434 1.30155 10 1.32268C8.85732 1.30244 7.72253 1.51623 6.66551 1.95089C5.60848 2.38555 4.65157 3.03188 3.85364 3.85014C3.03358 4.64761 2.38585 5.60486 1.95052 6.66267C1.51519 7.72047 1.3015 8.85635 1.32268 10C1.30224 11.1432 1.51627 12.2784 1.95158 13.3356C2.38688 14.3928 3.03422 15.3496 3.85364 16.1469C4.651 16.9662 5.60773 17.6134 6.66483 18.0487C7.72194 18.484 8.857 18.6976 10 18.6774Z" fill="black"/>
                        </svg>
                    </button>
                    <label class="search-form__label visually-hidden" for="SiteSearch">
                        Search site
                    </label>

                    <input
                        type="text"
                        id="SiteSearch"
                        name="q"
                        class="search-form__input"
                        placeholder="Search site"
                        aria-label="Search site"
                        v-model="props.query"
                        required />

                    <button class="search-form__button"
                            @click.prevent="triggerSearch(props.query)"
                            type="submit"
                            aria-label="search"
                            enterkeyhint="search" >
                        <span class="visually-hidden">Search</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <g clip-path="url(#clip0_1323_917)">
                                <path d="M0 6.49414C0 10.0748 2.91341 12.9883 6.49414 12.9883C7.91016 12.9883 9.20408 12.5326 10.2702 11.7676L14.2741 15.7796C14.4613 15.9668 14.7054 16.0563 14.9658 16.0563C15.5192 16.0563 15.9017 15.6413 15.9017 15.096C15.9017 14.8356 15.804 14.5996 15.6332 14.4288L11.6537 10.4248C12.4918 9.33433 12.9883 7.97526 12.9883 6.49414C12.9883 2.91341 10.0748 0 6.49414 0C2.91341 0 0 2.91341 0 6.49414ZM1.3916 6.49414C1.3916 3.67838 3.67838 1.3916 6.49414 1.3916C9.30992 1.3916 11.5967 3.67838 11.5967 6.49414C11.5967 9.30992 9.30992 11.5967 6.49414 11.5967C3.67838 11.5967 1.3916 9.30992 1.3916 6.49414Z" fill="black"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1323_917">
                                <rect width="16.2028" height="16.0563" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                </form>
            </div>

            <div class="site-search__nav" v-if="results?.length && !loading" v-cloak>
                <ul class="search-nav">
                    <li v-for="(tab, tabIndex) in tabs" class="search-nav__item" role="tab" :key="tabIndex">
                        <a
                            :href="tab.link"
                            class="search-nav__link"
                            :class="{'search-nav__link--current': tab.isActive,
                                     ['search-nav__link--' + tab.name]: true,
                                     'search-nav__link--disabled': tab.totalResults === 0}"
                            :aria-selected="tab.isActive ? 'true' : 'false'">
                            <span class="search-nav__link-title">{{ tab.name }}
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</template>

<script setup>
import {ref, watch} from "vue";
import {getState} from "../services/stateful";

const props = defineProps({
    loading: {
        type: Boolean,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    query: {
        type: String,
        required: false,
        default: '',
    },
    results: {
        type: Array,
        required: true
    }
});

const searchFilterParam = 'filter';
const tabs = ref([]);
const triggerSearch = getState('Search.Trigger');

function searchFilterUrl(filter, page) {
    const url = new URL(window.location);

    url.searchParams.set(searchFilterParam, filter);

    url.searchParams.set('page', page);
    url.searchParams.set('q', props.query.trim());

    return url.toString();
}

function getTotalResultsForTab(filter) {
    return props.results.filter(result => result.collectionType === filter).length;
}

watch(() => props.results, (newResults) => {
    const search = new URLSearchParams(window.location.search);

    tabs.value = [
        {
            filter: 'all',
            name: 'All',
            link: searchFilterUrl('all', 1),
            isActive: !search.has(searchFilterParam) || search.get(searchFilterParam) === 'all',
            totalResults: props.results.length,
        },
        {
            filter: 'events',
            name: 'Events',
            link: searchFilterUrl('events', 1),
            isActive: search.has(searchFilterParam) && search.get(searchFilterParam) === 'events',
            totalResults: getTotalResultsForTab('events'),
        },
        {
            filter: 'posts',
            name: 'News',
            link: searchFilterUrl('posts', 1),
            isActive: search.has(searchFilterParam) && search.get(searchFilterParam) === 'posts',
            totalResults: getTotalResultsForTab('posts'),
        },
    ];
});
</script>


<style scoped>

</style>
